import { stats } from '@/mocks/features';

export default function StatsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-primary-500">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-background-50/70">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}